export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00477.84f6ed0c.png";